import {http} from '@/http'

export default {
  listActive() {
    return http.get('/celulares/zonal/active')
  },
}
